// SEO utility functions for dynamic meta tag management

export const updateMetaTags = (title, description, keywords = '', ogImage = '/images/logo.webp') => {
  // Update title
  document.title = title;
  
  // Update meta description
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', description);
  }
  
  // Update keywords if provided
  if (keywords) {
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', keywords);
  }
  
  // Update Open Graph tags
  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) {
    ogTitle.setAttribute('content', title);
  }
  
  const ogDescription = document.querySelector('meta[property="og:description"]');
  if (ogDescription) {
    ogDescription.setAttribute('content', description);
  }
  
  const ogImageTag = document.querySelector('meta[property="og:image"]');
  if (ogImageTag) {
    ogImageTag.setAttribute('content', `https://radixtechs.com${ogImage}`);
  }
  
  // Update Twitter tags
  const twitterTitle = document.querySelector('meta[property="twitter:title"]');
  if (twitterTitle) {
    twitterTitle.setAttribute('content', title);
  }
  
  const twitterDescription = document.querySelector('meta[property="twitter:description"]');
  if (twitterDescription) {
    twitterDescription.setAttribute('content', description);
  }
  
  const twitterImage = document.querySelector('meta[property="twitter:image"]');
  if (twitterImage) {
    twitterImage.setAttribute('content', `https://radixtechs.com${ogImage}`);
  }
};

export const generateStructuredData = (type, data) => {
  let structuredData;
  
  switch (type) {
    case 'service':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": data.name,
        "description": data.description,
        "provider": {
          "@type": "Organization",
          "name": "Radix Technologies",
          "url": "https://radixtechs.com"
        },
        "areaServed": "Worldwide",
        "serviceType": data.serviceType || "IT Services"
      };
      break;
      
    case 'webpage':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": data.title,
        "description": data.description,
        "url": data.url,
        "isPartOf": {
          "@type": "WebSite",
          "name": "Radix Technologies",
          "url": "https://radixtechs.com"
        }
      };
      break;
      
    default:
      return;
  }
  
  // Create new script element for page-specific structured data
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(structuredData);
  
  // Add unique identifier to avoid duplicates
  script.id = `structured-data-${type}`;
  
  // Remove existing page-specific structured data
  const existing = document.getElementById(`structured-data-${type}`);
  if (existing) {
    existing.remove();
  }
  
  document.head.appendChild(script);
};

// Page-specific SEO configurations
export const seoConfig = {
  home: {
    title: "Radix Technologies - IT Services & Cloud Solutions",
    description: "Expert IT services & cloud solutions. 19+ years experience, 164+ projects delivered. DevOps, AI development, mobile apps & managed services.",
    keywords: "IT services, cloud solutions, DevOps automation, AI development, mobile development, managed services, technology advisory, quality assurance, UX UI design, outsourcing"
  },
  about: {
    title: "About Radix Technologies | 19+ Years IT Excellence",
    description: "Learn about Radix Technologies' journey, experienced team, and commitment to delivering exceptional IT services and cloud solutions worldwide.",
    keywords: "about radix technologies, IT company Palestine, technology team, IT expertise, company history, IT professionals"
  },
  services: {
    title: "IT Services - DevOps, Cloud, AI | Radix Technologies",
    description: "Comprehensive IT services including DevOps automation, cloud migration, AI development, mobile apps, quality assurance, and managed services.",
    keywords: "DevOps automation, cloud migration, managed IT services, mobile app development, quality assurance, AI development, technology advisory, UX UI design"
  },
  portfolio: {
    title: "Portfolio - Success Stories | Radix Technologies",
    description: "Explore successful projects including Cloudify, EarlySense, and enterprise solutions delivered by Radix Technologies for clients worldwide.",
    keywords: "IT portfolio, project case studies, client testimonials, technology projects, success stories, IT solutions"
  },
  careers: {
    title: "Careers - Join Our Team | Radix Technologies",
    description: "Build your IT career at Radix Technologies. Explore remote-first opportunities in software development, AI, DevOps, and quality assurance.",
    keywords: "IT careers, technology jobs, DevOps jobs, developer positions, QA careers, remote work, Palestine jobs, IT opportunities"
  },
  plans: {
    title: "Pricing Plans - Flexible IT Solutions | Radix",
    description: "Compare flexible IT engagement models for startup MVPs, dedicated teams, cloud migration, and managed services from Radix Technologies.",
    keywords: "IT service pricing, cloud solution plans, managed service costs, technology pricing, IT consulting rates, service packages"
  },
  contact: {
    title: "Contact Us - Get in Touch | Radix Technologies",
    description: "Contact Radix Technologies for IT service needs. Get a free consultation and discover how we can transform your business with technology.",
    keywords: "contact IT company, technology consultation, IT support contact, business inquiry, project discussion, free consultation"
  },
  blog: {
    title: "Blog - IT, Cloud & AI Insights | Radix Technologies",
    description: "Practical insights on software delivery, cloud migration, DevOps, AI development, and product strategy from the Radix Technologies team.",
    keywords: "IT blog, cloud blog, DevOps insights, AI development articles, software delivery, technology strategy"
  }
};

export const arabicSeoConfig = {
  home: {
    title: 'راديكس تكنولوجيز - خدمات تقنية وحلول سحابية',
    description: 'خدمات تقنية وحلول سحابية بخبرة تزيد عن 19 عاماً، تشمل DevOps والذكاء الاصطناعي وتطبيقات الهاتف والخدمات المُدارة.',
    keywords: 'خدمات تقنية، حلول سحابية، ذكاء اصطناعي، تطوير تطبيقات، خدمات مُدارة'
  },
  about: {
    title: 'من نحن | راديكس تكنولوجيز',
    description: 'تعرّف على راديكس تكنولوجيز وفريقنا وخبرتنا والتزامنا بتقديم خدمات تقنية وحلول سحابية استثنائية حول العالم.',
    keywords: 'راديكس تكنولوجيز، شركة تقنية، فريق برمجيات، خبرات تقنية'
  },
  services: {
    title: 'خدمات تقنية وسحابية وذكاء اصطناعي | راديكس',
    description: 'خدمات تقنية شاملة تشمل DevOps والهجرة السحابية وتطوير الذكاء الاصطناعي وتطبيقات الهاتف وضمان الجودة والخدمات المُدارة.',
    keywords: 'DevOps، هجرة سحابية، ذكاء اصطناعي، تطبيقات هاتف، ضمان الجودة'
  },
  portfolio: {
    title: 'أعمالنا وقصص النجاح | راديكس تكنولوجيز',
    description: 'استكشف مشاريع البرمجيات والحوسبة السحابية وتطبيقات الهاتف التي نفذتها راديكس تكنولوجيز لعملائها حول العالم.',
    keywords: 'أعمال تقنية، مشاريع برمجيات، قصص نجاح، حلول سحابية'
  },
  careers: {
    title: 'الوظائف - انضم إلى فريقنا | راديكس تكنولوجيز',
    description: 'طوّر مسيرتك المهنية في راديكس تكنولوجيز واستكشف فرص العمل في تطوير البرمجيات والذكاء الاصطناعي وDevOps وضمان الجودة.',
    keywords: 'وظائف تقنية، وظائف برمجة، وظائف DevOps، وظائف ذكاء اصطناعي'
  },
  plans: {
    title: 'خطط وأساليب تعاون مرنة | راديكس تكنولوجيز',
    description: 'قارن نماذج التعاون المرنة للمشاريع الناشئة والفرق المخصصة والهجرة السحابية والخدمات المُدارة.',
    keywords: 'خطط خدمات تقنية، فريق مخصص، خدمات مُدارة، أسعار تطوير البرمجيات'
  },
  contact: {
    title: 'تواصل معنا | راديكس تكنولوجيز',
    description: 'تواصل مع راديكس تكنولوجيز لمناقشة احتياجاتك التقنية والحصول على استشارة حول مشروعك القادم.',
    keywords: 'تواصل مع شركة تقنية، استشارة تقنية، طلب مشروع'
  },
  blog: {
    title: 'المدونة - رؤى تقنية وسحابية | راديكس تكنولوجيز',
    description: 'رؤى عملية حول تسليم البرمجيات والهجرة السحابية وDevOps وتطوير الذكاء الاصطناعي واستراتيجية المنتجات.',
    keywords: 'مدونة تقنية، حوسبة سحابية، DevOps، ذكاء اصطناعي، تطوير برمجيات'
  }
};
